import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_SLAVES_TO_DARKNESS: {
    name: 'Battletome: Slaves To Darkness',
    type: 'battletome',
  },
  ERRATA_JANUARY_2023: {
    name: 'Errata (January 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2022/11/ksqazT5l435bK8TK.pdf',
  },
} satisfies TRuleSources

export default rule_sources
